<template>
  <div class="showreel">
    <button class="showreel__btn" v-if="!showreel" @click="toggleShowreel">
      <img src="/showreel.svg" alt="Voir mon showreel"  />
    </button>
    <div class="showreel__iframe" v-else>
      <button class="closeShowreel" @click="showreel = false">X</button>
      <iframe
                title="Showreel Pauline FUCHS 2025"
                src="https://player.vimeo.com/video/477701835"
                width="1200"
                height="675"
                frameborder="0"
                allow="autoplay; fullscreen" ></iframe>
    </div>
  </div>
</template>
<script setup lang="ts">
/*  IMPORTS  */

/*  VARIABLES  */
const showreel = ref(false);
/*  FUNCTIONS  */

const toggleShowreel = () => {
  showreel.value = !showreel.value;
};
</script>

<style lang="scss">
.showreel {
  position: absolute;
  bottom: 0%;
  right: 0;
  @media screen and (max-width: 1035px) {
    bottom: -5%;
    right: 5%;
  }
  &__btn {
    width: 180px;
    height: 100px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    @media screen and (max-width: 1035px) {
      width: 125px;
      height: 80px;
    }
    img {
      width: 100%;
    }
  }
  &__iframe {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba($violet_light, 0.7);
    z-index: 6;
    display: flex;
    align-items: center;
    justify-content: center;
    .closeShowreel {
      position: absolute;
      top: 160px;
      right: 20px;
      width: 50px;
      height: 50px;
      background: $violet;
      border: 1px solid $violet;
      border-radius: 100%;
      cursor: pointer;
      color: white;
    }
  }
}
</style>
